import { MemberOrderFloorVO, MemberOrderInfoVo } from "../checkout.interface";
import { USER_TYPE_ENUM } from "../constants/constants";

/**
 * 将会员订单成功页返回转化为传统楼层结构
 * @param floors
 */
function getFormatMemberOrderSuccessInfo(floors:MemberOrderFloorVO[]) : MemberOrderInfoVo {
  // 会员订单成功结果
  let memberOrderInfo:MemberOrderInfoVo = {
    memberPointInfo : {
      bgInfo:{},
      memberInfoList:[]
    }
  }
  if (!floors || !floors.length) {
    return memberOrderInfo;
  }  
  floors.map(floor => {
    if(floor.floorType===USER_TYPE_ENUM.PLUS_ORDER){
      // 处理会员积分数据
      const bgInfo = {
        plusIcon:floor.plusIcon,
        exclusiveSaveText:floor.exclusiveSaveText,
        plusBackGroundIcon:floor.plusBackGroundIcon,
      }
      const memberInfoList = floor.orderPaySuccessFloorItems || []
      const memberPointInfo ={
        bgInfo,
        memberInfoList
      }
      memberOrderInfo.memberPointInfo = memberPointInfo
    }
  })
  return memberOrderInfo;
}

export { getFormatMemberOrderSuccessInfo };
